export enum DealProcessingStatus {
  NotAvailable = 'NOT_AVAILABLE',
  Waiting = 'WAITING',
  Processed = 'PROCESSED',
}

export enum DealProcessingEvents {
  Updated = 'ProcessingWasUpdated',
}
